import { render, staticRenderFns } from "./weightRepInput.vue?vue&type=template&id=a00cabd8&scoped=true"
import script from "./weightRepInput.vue?vue&type=script&lang=js"
export * from "./weightRepInput.vue?vue&type=script&lang=js"
import style0 from "./weightRepInput.vue?vue&type=style&index=0&id=a00cabd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00cabd8",
  null
  
)

export default component.exports